import bandsConfig from '@public/bands.json';

export type BandId = 'excellent' | 'covered' | 'limited' | 'far' | 'out_of_region';

export type BandConfig = {
  coveredFromKm: number;
  limitedFromKm: number;
  farFromKm: number;
  outOfRegionFromKm: number;
};

export const BANDS: BandConfig = bandsConfig;

export const resolveBand = (distanceKm: number, config: BandConfig = BANDS): BandId => {
  if (distanceKm >= config.outOfRegionFromKm) {
    return 'out_of_region';
  }
  if (distanceKm >= config.farFromKm) {
    return 'far';
  }
  if (distanceKm >= config.limitedFromKm) {
    return 'limited';
  }
  if (distanceKm >= config.coveredFromKm) {
    return 'covered';
  }
  return 'excellent';
};
